const MAX_MONTH_NUMBER = 12;
const MIN_MONTH_NUMBER = 1;

const SS_SWITCH_CONFIG = [
  {
    text: 'SOCIAL_SECURITY.SOCIAL_SECURITY_SEARCH.QUOTATION',
    value: 'quotation',
  },
  {
    text: 'SOCIAL_SECURITY.SOCIAL_SECURITY_SEARCH.SETTLEMENT',
    value: 'settlement',
  }
];

export {
    MAX_MONTH_NUMBER,
    MIN_MONTH_NUMBER,
    SS_SWITCH_CONFIG,
};



// WEBPACK FOOTER //
// ./client/app/social-security.module/common/domain/constants.js